/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { UserContext } from "../../../context/userContext";
import { useNavigate, useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import { Row, Col, Form, Input, Label, Button, CardText, CardTitle, FormFeedback, UncontrolledTooltip } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API } from "../../../config/api";
import { FaUser, FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit, FaClosedCaptioning, FaTimes, FaBold, FaItalic, FaStrikethrough, FaMicrophone, FaTelegram, FaTelegramPlane } from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import Modal from 'react-bootstrap/Modal';
import "bulma/css/bulma.css";
import "../Styled.css"
import LoaderHome from "../../Loader/LoaderHome"
import swal from "sweetalert";
import React from 'react';
import logo_kemenkes from "../../../assets/signature/logo_kemeskes.png"
import axios from "axios";
import { components } from "react-select";

export default function ModalRoleAdd(props) {
  // untuk code uuid ini :  100465661 merupakan organisasi ID GRATIA JAYA
  // untuk code uuid ini : 
  const token = localStorage.getItem("token");


  // Untuk Close Proops Data;
  const rolesData = JSON.parse(localStorage.getItem('roles')) || [];
  // const filteredRoles = rolesData.filter(role => role.name === 'Doctor');
  // const filteredRolesAdmin = rolesData.filter(role => role.name === 'Admin');
  // const filteredRolesANurse = rolesData.filter(role => role.name === 'Nurse');
  const levelUser = localStorage.getItem('level');

  const [isAppointmentExists, setIsAppointmentExists] = useState(false);
  const [buttonText, setButtonText] = useState("Loading");
  const [buttonColor, setButtonColor] = useState("primary");
  const [buttonDisable, setButtonDisable] = useState("");

  const [loading, setLoading] = useState(false);
  const [getDataPatients, setGetDataPatients] = useState([]);
  const [getDataDoctorByID, setGetDataDoctorByID] = useState([]);
  const [getDataPhysicalCheck, setGetDataPhysicalCheck] = useState([]);
  const [getDataPhysicalCheckAppointment, setGetDataPhysicalCheckAppointment] = useState(null);
  const [getDataPhysicalCheckSoapPatient, setGetDataPhysicalCheckSoapPatient] = useState(null);
  const [getDataAppointmentSsp, setGetDataAppointmentSsp] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [getDataSSP, setGetDataSSP] = useState([]);
  const [status, setStatus] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [dataMedicalRecord, setGetDataMedicalRecord] = useState("");
  const [dataRoomSatuSehat, setGetDataRoomSatuSehat] = useState("");

  const [dataToothOcclusion, setGetDataToothOcclusi] = useState([]);
  const [dataToothTorusPalatinus, setGetDataToothTorusPalatinus] = useState([]);
  const [dataToothTorusMandibularis, setGetDataToothTorusMandibularis] = useState([]);
  const [dataToothPalatum, setGetDataToothPalatum] = useState([]);
  const [dataToothDiastema, setGetDataToothDiastema] = useState([]);
  const [dataToothAnomali, setGetDataToothAnomali] = useState([]);

  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };

  const [form, setForm] = useState({
    id_appointment: "",
    id_patient: "",
    id_doctor: "",
    patient_name: "",
    token_satu_sehat: "",
    date_appointment: "",
    time_appointment: "",
    arrangement_data: "",
    appointment_ssp: ""
  });

  const GetDataResponseRoomFromSatuSehat = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/location', {
        params: {
          'id_room': form?.arrangement_data.id_room
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      if (response?.data.entry && response.data.entry.length !== 0) {
        if (response?.status === 200 || response?.status === 201) {
          setLoading(false);
          setGetDataRoomSatuSehat(response.data.entry[0].resource);
        }
      } else {
        swal({
          title: 'Info',
          text: 'No data found for this ID Room',
          icon: 'info',
          timer: 3000,
          buttons: false
        });
      }
    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: error.response?.data?.message || 'Something went wrong',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataPatients = async () => {
    try {
      setLoading(true)
      const response = await API.get(`/transaction-service/patients/${form?.id_patient}`, fetchParams)
      // Checking process
      if (response?.status === 200 || response?.status === 201) {
        setGetDataPatients(response.data.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataMedicalRecord = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/emr-service/medical-invoices/${form?.id_appointment}`, fetchParams)
      // Checking process
      if (response?.status === 200 || response?.status === 201) {
        setGetDataMedicalRecord(response.data.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  // const GetResponseDataToothOcclusion = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/occlusis/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothOcclusi(response.data.data)
  //       // setGetDataMedicalRecord(response.data.data)
  //       setLoading(false)
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  // const GetResponseDataToothTorusPalatinus = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/torus-palatinuses/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothTorusPalatinus(response.data.data)
  //       setLoading(false)
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  // const GetResponseDataToothTorusMandibularis = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/torus-mandibularises/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothTorusMandibularis(response.data.data)
  //       setLoading(false)
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  // const GetResponseDataToothPalatum = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/palata/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothPalatum(response.data.data)
  //       setLoading(false)
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  // const GetResponseDataToothDiastema = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/diastemas/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothDiastema(response.data.data)
  //       setLoading(false)
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  // const GetResponseDataToothAnomali = async () => {
  //   try {
  //     // e.preventDefault();
  //     setLoading(true)

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };
  //     const response = await API.get(`/emr-service/dental-mains/anomalis/${form?.id_patient}/${form?.id_appointment}`, { ...fetchParams, params })
  //     // Checking process
  //     if (response?.status === 200 || response?.status === 201) {
  //       setGetDataToothAnomali(response.data.data)
  //       setLoading(false)
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // }

  const GetResponseDataDoctorByID = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/user-service/privileges/users/${form?.id_doctor}`, fetchParams)
      // Checking process
      if (response?.status === 200 || response?.status === 201) {
        setGetDataDoctorByID(response.data.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataPhisicalChecks = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/emr-service/phy-checks/patient/${form?.id_appointment}`, fetchParams)
      // Checking process
      if (response?.status === 200 || response?.status === 201) {
        setGetDataPhysicalCheck(response.data.data)
        setGetDataPhysicalCheckAppointment(response.data.appointment)
        setGetDataPhysicalCheckSoapPatient(response.data.soapPatients)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `Lengkapi data physical check`,
        icon: 'warning',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataAppointmentSSP = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/user-service/appointment-ssp`, fetchParams)
      if (response?.status === 200 || response?.status === 201) {
        setGetDataSSP(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)
      if (error.response.data.data.length !== 0) {
        swal({
          title: 'Failed',
          text: `${error.response.data.message}`,
          icon: 'error',
          timer: 3000,
          buttons: false
        });
      }
    }
  }

  const GetResponseDataAppointmentSSPByIdAppointment = async () => {
    try {

      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/user-service/appointment-ssp/${form?.id_appointment}`, fetchParams)

      if ((response?.status === 200 || response?.status === 201) && response?.data?.data?.length !== 0) {
        setGetDataAppointmentSsp(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)
      if (error.response.data.data.length !== 0) {
        swal({
          title: 'Failed',
          text: `${error.response.data.message}`,
          icon: 'error',
          timer: 3000,
          buttons: false
        });
      }

      if (error.response.data.data.length === 0) {
        setButtonText("Kirim Encounter");
        // Insert data for login process
        const token = localStorage.getItem('token');

        const responsePasienLocal = await API.get(`/transaction-service/patients/${form?.id_patient}`, fetchParams)

        const responseDoctorLocal = await API.get(`/user-service/privileges/users/${form?.id_doctor}`, fetchParams)

        const responseLocation = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/location', {
          params: {
            'id_room': form?.arrangement_data.id_room
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`,
          }
        });

        const responsePasien = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
          params: {
            'id_nik': `${responsePasienLocal.data.data.nic_number}`
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`,
          }
        });

        let patientId;
        if (!responsePasien?.data?.entry || responsePasien?.data?.entry.length === 0) {
          const newPatient = await axios.post(
            `https://api-ts.signatureanugerah.co.id/api/satu-sehat/patient`,
            {
              nic_number: responsePasienLocal.data.data.nic_number,
              first_name: responsePasienLocal.data.data.first_name,
              last_name: responsePasienLocal.data.data.last_name,
              phone_number: responsePasienLocal.data.data.phone_number,
              gender: responsePasienLocal.data.data.gender,
              date_birth: responsePasienLocal.data.data.date_birth,
              residence_address: responsePasienLocal.data.data.residence_address,
              province: responsePasienLocal.data.data.province,
              regency: responsePasienLocal.data.data.regency,
              district: responsePasienLocal.data.data.district,
              sub_district: responsePasienLocal.data.data.sub_district,
              status: responsePasienLocal.data.data.status,
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
              }
            }
          );

          patientId = newPatient?.id;
        } else {
          patientId = responsePasien.data.entry[0].resource.id;
        }

        const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
          params: {
            'id_patient': patientId
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`,
          }
        });

        const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter',
          {
            "patient_id": responsePasien.data.entry[0].resource.id,
            "id_appointment": form?.id_appointment,
            "date_appointment": form?.date_appointment,
            "time_appointment": form?.time_appointment,
            "patient_firstname": responsePasienLocal.data.data.first_name,
            "patient_lastname": responsePasienLocal.data.data.last_name,
            "doctor_firstname": responseDoctorLocal.data.data.user_detail?.firstname,
            "doctor_lastname": responseDoctorLocal.data.data.user_detail?.lastname,
            "room_id": responseLocation.data.entry[0].resource.id,
            "room_name": responseLocation.data.entry[0].resource.description
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );


        if (response?.data.status === "arrived") {
          props.GetResponseData()
          const responseSSP = await API.post("/user-service/appointment-ssp/store", {
            id_appointment: form?.id_appointment,
            id_appointment_ssp: responseEncounter?.data?.entry[0].resource?.id,
            id_patient: form?.id_patient,
            id_patient_ssp: response.data.entry[0].resource.id,
            status_sistole_ssp: 0,
            status_distole_ssp: 0,
            status_observation_ssp: 0,
            status_diagnosis_ssp: 0,
            status_procedure_ssp: 0,
            status_condition_ssp: 0,
            status_odontogram_ssp: 0,
          }, fetchParams);

          if (responseSSP.status === 200) {
            props.GetResponseData()
            GetResponseDataAppointmentSSP()
          }
        }
      }
    }
  }



  useEffect(() => {
    setForm({
      ...form,
      id_appointment: props?.idAppointmentModalSatuSehat === null ? "" : props?.idAppointmentModalSatuSehat,
      id_patient: props?.idPatientModalSatuSehat === null ? "" : props?.idPatientModalSatuSehat,
      id_doctor: props?.idDoctorModalSatuSehat === null ? "" : props?.idDoctorModalSatuSehat,
      patient_name: props?.patientNameModalSatuSehat === null ? "" : props?.patientNameModalSatuSehat,
      token_satu_sehat: props?.getDataSatuSehat === null ? "" : props?.getDataSatuSehat,
      date_appointment: props?.dateSatuSehat === null ? "" : props?.dateSatuSehat,
      time_appointment: props?.timeSatuSehat === null ? "" : props?.timeSatuSehat,
      arrangement_data: props?.arrangementSatuSehat === null ? "" : props?.arrangementSatuSehat,
      appointment_ssp: props?.appointmentSSP === null ? "" : props?.appointmentSSP
    });
  }, [props])

  useEffect(() => {
    if (
      form?.id_patient !== "" &&
      form?.id_doctor !== "" &&
      form?.id_appointment !== "" &&
      form?.date_appointment !== "" &&
      form?.time_appointment !== "" &&
      form?.arrangement_data !== ""
    ) {
      setLoading(true);

      Promise.allSettled([
        GetResponseDataPatients(),
        GetResponseDataDoctorByID(),
        GetResponseDataPhisicalChecks(),
        GetResponseDataMedicalRecord(),
        // GetResponseDataToothOcclusion(),
        // GetResponseDataToothTorusPalatinus(),
        // GetResponseDataToothTorusMandibularis(),
        // GetResponseDataToothPalatum(),
        // GetResponseDataToothDiastema(),
        // GetResponseDataToothAnomali(),
        GetDataResponseRoomFromSatuSehat(),
        GetResponseDataAppointmentSSPByIdAppointment(),
        GetResponseDataAppointmentSSP(),

      ]).finally(() => {
        setLoading(false);
      });
    }
  }, [form?.id_patient, form?.id_doctor, form?.id_appointment]);

  const UpdateDataSistoleSSPLocal = async (patient_id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_sistole_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: getDataAppointmentSsp?.id_appointment_ssp
      }, fetchParams);

    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateDataDistoleSSPLocal = async (patient_id, id) => {
    try {
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_distole_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: id,
      }, fetchParams);

    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateDataObservationSSPLocal = async (patient_id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_observation_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: getDataAppointmentSsp?.id_appointment_ssp,
      }, fetchParams);
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateDataDiagnosisSSPLocal = async (patient_id, id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_diagnosis_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: id
      }, fetchParams);
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateDataProcedureSSPLocal = async (patient_id, id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_procedure_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: id
      }, fetchParams);
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateDataConditionSSPLocal = async (patient_id, id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_condition_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: id
      }, fetchParams);
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const UpdateGetResponseDataToothCondition = async (patient_id, id) => {
    try {
      setLoading(true);
      await API.put(`/user-service/appointment-ssp/${form?.id_appointment}`, {
        status_odontogram_ssp: 1,
        id_patient_ssp: patient_id,
        id_appointment_ssp: id
      }, fetchParams);
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Terjadi kesalahan'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    } finally {
      setLoading(false);
    }
  };

  const PostDataPatientEcounter = async (patient_id, encounter_id) => {
    try {
      // if (!patient_id) {
      //   return swal({ title: "Error", text: "Patient ID is required", icon: "error", timer: 3000 });
      // }
      // if (!form?.id_appointment) {
      //   return swal({ title: "Error", text: "Appointment ID is required", icon: "error", timer: 3000 });
      // }
      // if (!form?.date_appointment) {
      //   return swal({ title: "Error", text: "Date appointment is required", icon: "error", timer: 3000 });
      // }
      // if (!form?.time_appointment) {
      //   return swal({ title: "Error", text: "Time appointment is required", icon: "error", timer: 3000 });
      // }
      // if (!getDataPatients?.first_name) {
      //   return swal({ title: "Error", text: "Patient first name is required", icon: "error", timer: 3000 });
      // }
      // if (!getDataPatients?.last_name) {
      //   return swal({ title: "Error", text: "Patient last name is required", icon: "error", timer: 3000 });
      // }
      // if (!getDataDoctorByID?.user_detail?.firstname) {
      //   return swal({ title: "Error", text: "Doctor first name is required", icon: "error", timer: 3000 });
      // }
      // if (!getDataDoctorByID?.user_detail?.lastname) {
      //   return swal({ title: "Error", text: "Doctor last name is required", icon: "error", timer: 3000 });
      // }
      // if (!dataRoomSatuSehat?.id) {
      //   return swal({ title: "Error", text: "Room ID is required", icon: "error", timer: 3000 });
      // }
      // if (!dataRoomSatuSehat?.name) {
      //   return swal({ title: "Error", text: "Room name is required", icon: "error", timer: 3000 });
      // }


      // Insert data for login process
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter',
        {
          "patient_id": patient_id,
          "id_appointment": form?.id_appointment,
          "date_appointment": form?.date_appointment,
          "time_appointment": form?.time_appointment,
          "patient_firstname": getDataPatients?.first_name,
          "patient_lastname": getDataPatients?.last_name,
          "doctor_firstname": getDataDoctorByID?.user_detail?.firstname,
          "doctor_lastname": getDataDoctorByID?.user_detail?.lastname,
          "room_id": dataRoomSatuSehat.id,
          "room_name": dataRoomSatuSehat.name
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );



      if (response?.data.status === "arrived") {
        props.GetResponseData()
        const responseSSP = await API.post("/user-service/appointment-ssp/store", {
          id_appointment: form?.id_appointment,
          id_appointment_ssp: encounter_id,
          id_patient: form?.id_patient,
          id_patient_ssp: patient_id,
          status_sistole_ssp: 0,
          status_distole_ssp: 0,
          status_observation_ssp: 0,
          status_diagnosis_ssp: 0,
          status_procedure_ssp: 0,
          status_condition_ssp: 0,
          status_odontogram_ssp: 0,
        }, fetchParams);

        if (responseSSP.status === 200) {
          // GetResponseDataToothCondition(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          // PostDataToothOcclusion(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          // PostDataToothTorusPalatinus(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          // PostDataToothTorusMandibularis(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          // PostDataToothPalatum(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          // PostDataToothDiastema(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          // PostDataToothAnomali(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          GetResponseDataAppointmentSSP()
        }
      }

    } catch (error) {
      setLoading(false)
      if (error.response.data.error.issue[0].code === "duplicate") {
        const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
          params: {
            'id_patient': patient_id
          },
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`,
          }
        });

        if (getDataAppointmentSsp?.status_sistole_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataPatientSistole(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
          if (error.response.data.error.issue[0].code === 'duplicate') {
            UpdateDataSistoleSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
        }
        if (getDataAppointmentSsp?.status_distole_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataPatientDistole(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
          if (error.response.data.error.issue[0].code === 'duplicate') {
            UpdateDataDistoleSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
        }
        if (getDataAppointmentSsp?.status_observation_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataPatientSuhu(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }

          if (error.response.data.error.issue[0].code === 'duplicate') {
            UpdateDataObservationSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
        }
        if (getDataAppointmentSsp?.status_diagnosis_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataDiagnosis(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }

          if (error.response.data.error.issue[0].code === 'duplicate') {
            UpdateDataDiagnosisSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
          }
        }

        if (getDataAppointmentSsp?.status_procedure_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataTindakan(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }

          if (error.response.data.error.issue[0].code === 'duplicate') {
            UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
        }

        if (getDataAppointmentSsp?.status_condition_ssp === 0) {
          if (error.response.data.error.issue[0].code !== 'duplicate') {
            PostDataKeluhanUtama(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
            PostDataRiwayatPenyakit(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
            PostDataGolonganDarah(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
          if (error.response.data.error.issue[0].code === 'duplicate') {

            // UpdateDataConditionSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
          }
        }
      } else {
        setLoading(false)
        swal({
          title: 'Failed',
          text: "Error",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  }

  const PostDataPatientSistole = async (patient_id, id) => {
    try {
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/sistole',
        {
          "patient_id": patient_id,
          "id_encounter": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "doctor_firstname": `${getDataDoctorByID?.user_detail?.firstname}`,
          "doctor_lastname": `${getDataDoctorByID?.user_detail?.lastname}`,
          "blood_pressure": parseInt(getDataPhysicalCheck?.blood_pressure.split("/")[0]),
          "created_at": `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );


      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        if (getDataAppointmentSsp.length === 0) {
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false
          })
        }
      } else {
        swal({
          title: 'Failed',
          text: "Sistole wajib diisi",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }

    } catch (error) {
      if (error.response.data.error.issue[0].code !== "duplicate") {
        setLoading(false)
        swal({
          title: 'Failed',
          text: error?.response?.data.error.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  }

  // const GetResponseDataToothCondition = async (patient_id, id) => {
  //   try {
  //     setLoading(true);

  //     const toothNumbers = [
  //       "18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28",
  //       "55", "54", "53", "52", "51", "61", "62", "63", "64", "65",
  //       "85", "84", "83", "82", "81", "71", "72", "73", "74", "75",
  //       "48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"
  //     ];

  //     const params = {
  //       page: 0,
  //       limit: 'all',
  //       ascending: 0,
  //       id_appointment: `${form?.id_appointment}`
  //     };

  //     const [
  //       { data: conditionData },
  //       { data: restorationData },
  //       { data: restorationMaterialData },
  //       { data: protesaData },
  //       { data: protesaMaterialData }
  //     ] = await Promise.all([
  //       API.get(`/emr-service/dental-mains/tooth/condition/${form?.id_patient}`, { ...fetchParams, params }),
  //       API.get(`/emr-service/dental-mains/tooth/restoration/${form?.id_patient}`, { ...fetchParams, params }),
  //       API.get(`/emr-service/dental-mains/tooth/restoration-material/${form?.id_patient}`, { ...fetchParams, params }),
  //       API.get(`/emr-service/dental-mains/tooth/protesa/${form?.id_patient}`, { ...fetchParams, params }),
  //       API.get(`/emr-service/dental-mains/tooth/protesa-material/${form?.id_patient}`, { ...fetchParams, params })
  //     ]);


  //     const positions = [];
  //     const components = [];

  //     toothNumbers.forEach(tooth => {
  //       const condition = conditionData.data?.filter(item => item.tooth_number === tooth) || [];
  //       const restoration = restorationData.data?.filter(item => item.tooth_number === tooth) || [];
  //       const restorationMaterial = restorationMaterialData.data?.filter(item => item.tooth_number === tooth) || [];
  //       const protesa = protesaData.data?.filter(item => item.tooth_number === tooth) || [];
  //       const protesaMaterial = protesaMaterialData.data?.filter(item => item.tooth_number === tooth) || [];

  //       if (condition.length > 0) {
  //         condition.forEach(item => {
  //           if (item.code_position && item.display_position) {
  //             positions.push({
  //               system: item.system_position,
  //               code: item.code_position,
  //               display: item.display_position,
  //             });
  //           }
  //           if (item.code_condition && item.display_condition) {
  //             components.push({
  //               system: item.system_condition,
  //               code: item.code_condition,
  //               display: item.display_condition,
  //             });
  //           }
  //         });
  //       }
  //       if (restoration.length > 0) {
  //         restoration.forEach(item => {
  //           if (item.code_restoration && item.display_restoration) {
  //             components.push({
  //               system: item.system_restoration,
  //               code: item.code_restoration,
  //               display: item.display_restoration,
  //             });
  //           }
  //         });
  //       }
  //       if (restorationMaterial.length > 0) {
  //         restorationMaterial.forEach(item => {
  //           if (item.code_restoration_material && item.display_restoration_material) {
  //             components.push({
  //               system: item.system_restoration_material,
  //               code: item.code_restoration_material,
  //               display: item.display_restoration_material,
  //             });
  //           }
  //         });
  //       }
  //       if (protesa.length > 0) {
  //         protesa.forEach(item => {
  //           if (item.code_protesa && item.display_protesa) {
  //             components.push({
  //               system: item.system_protesa,
  //               code: item.code_protesa,
  //               display: item.display_protesa,
  //             });
  //           }
  //         });
  //       }
  //       if (protesaMaterial.length > 0) {
  //         protesaMaterial.forEach(item => {
  //           if (item.code_protesa_material && item.display_protesa_material) {
  //             components.push({
  //               system: item.system_protesa_material,
  //               code: item.code_protesa_material,
  //               display: item.display_protesa_material,
  //             });
  //           }
  //         });
  //       }
  //     });


  //     const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
  //       params: {
  //         'id_nik': `${getDataPatients?.nic_number}`
  //       },
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": `${token}`,
  //       }
  //     });

  //     const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
  //       params: {
  //         'id_patient': responsePatient?.data?.entry[0].resource?.id
  //       },
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": `${token}`,
  //       }
  //     });

  //     const payload = {
  //       patient_id: responsePatient?.data?.entry[0].resource?.id,
  //       id_encounter: responseEncounter?.data?.entry[0].resource?.id,
  //       patient_firstname: getDataPatients?.first_name,
  //       patient_lastname: getDataPatients?.last_name,
  //       created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
  //       positions,
  //       components
  //     };

  //     if (positions.length === 0) {
  //       alert("Tidak ada data kondisi gigi yang akan dikirim.");
  //       setLoading(false);
  //       return;
  //     }

  //     // POST to backend
  //     await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-condition', payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": `${token}`
  //       }
  //     });

  //     swal({
  //       title: "Sukses",
  //       text: "Data berhasil dikirim",
  //       icon: "success",
  //       timer: 3000,
  //       buttons: false
  //     });

  //     props.GetResponseData();
  //     setLoading(false);

  //   } catch (error) {
  //     setLoading(false);
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response?.data?.message || error.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   }
  // };


  const PostDataPatientDistole = async (patient_id, id) => {
    try {
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/distole',
        {
          "patient_id": patient_id,
          "id_appointment": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "doctor_firstname": `${getDataDoctorByID?.user_detail?.firstname}`,
          "doctor_lastname": `${getDataDoctorByID?.user_detail?.lastname}`,
          "blood_pressure": parseInt(getDataPhysicalCheck?.blood_pressure.split("/")[1]),
          "created_at": `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );
      // Checking process
      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        if (getDataAppointmentSsp.length === 0) {
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false
          })
        }
      } else {
        swal({
          title: 'Failed',
          text: "Distole wajib diisi",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    } catch (error) {
      if (error.response.data.error.issue[0].code !== "duplicate") {
        setLoading(false)
        swal({
          title: 'Failed',
          text: error?.response?.data.error.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  }

  const PostDataPatientSuhu = async (patient_id, id) => {
    try {
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/observation',
        {
          "patient_id": patient_id,
          "id_appointment": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "doctor_firstname": `${getDataDoctorByID?.user_detail?.firstname}`,
          "doctor_lastname": `${getDataDoctorByID?.user_detail?.lastname}`,
          "body_temperature": parseInt(getDataPhysicalCheck?.body_temperature),
          "created_at": `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      // Checking process
      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        if (form?.status_observation_ssp === false || form?.status_observation_ssp === 0) {
          // UpdateDataObservationSSPLocal()
        }
        setLoading(false)
      }
    } catch (error) {
      if (error.response.data.error.issue[0].code !== "duplicate") {
        setLoading(false)
        swal({
          title: 'Failed',
          text: error?.response?.data.error.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  }

  const PostDataDiagnosis = async (patient_id, id) => {
    try {
      setLoading(true)
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/diagnosis',
        {
          "patient_id": patient_id,
          "id_appointment": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "doctor_firstname": `${getDataDoctorByID?.user_detail?.firstname}`,
          "doctor_lastname": `${getDataDoctorByID?.user_detail?.lastname}`,
          "code_diagnose": dataMedicalRecord?.medical_treatment_invoices?.[0]?.medical_record?.code_diagnose,
          "diagnose": dataMedicalRecord?.medical_treatment_invoices?.[0]?.medical_record?.diagnose,
          "created_at": `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      // Checking process
      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        if (form?.status_diagnosis_ssp === false || form?.status_diagnosis_ssp === 0) {
          UpdateDataDiagnosisSSPLocal(patient_id, id)
        }
        setLoading(false)
      }

    } catch (error) {
      setLoading(false)
      if (levelUser === 'developer') {
        if (error.response.data.error.issue[0].code !== "duplicate") {
          swal({
            title: 'Not Found',
            text: error.response.data.error.issue[0].details.text,
            icon: 'error',
            timer: 3000,
            buttons: false
          })
        }

      }
      if (levelUser === 'user') {
        const errorMessage = error.response.data.error.issue[0].details.text;
        const match = errorMessage.match(/'([^']+)'/);
        if (match) {
          swal({
            title: 'Not Found',
            text: `Code ${match[0]} ICD-10 `,
            icon: 'error',
            timer: 3000,
            buttons: false
          })
        }
      }

      if (error.response.data.error.issue[0].code !== "duplicate") {
        setLoading(false)
        swal({
          title: 'Failed',
          text: error?.response?.data.error.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }

    }
  }

  const PostDataTindakan = async (patient_id, id) => {
    try {
      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/procedure',
        {
          "patient_id": patient_id,
          "id_appointment": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "code": dataMedicalRecord?.medical_treatment_invoices
            ?.flatMap(invoice => invoice?.medical_record?.treatment_plan_detail?.treatment_data) || []
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      // Handle the response
      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false,
        });

        UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
        setLoading(false);
      }
    } catch (error) {
      if (error.response.data.issue[0].code !== "duplicate") {
        swal({
          title: 'Failed',
          text: error?.response?.message,
          // text: "heloo",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  };

  const PostDataToothOcclusion = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothOcclusion) {
        console.log(item, "occlusion")
        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          occlusi: item.dental_occlusi.map(occlusion => ({
            system: occlusion.system,
            code: occlusion.code,
            display: occlusion.display
          }))
        };


        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-occlusion',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });

          // UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const PostDataToothTorusPalatinus = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothTorusPalatinus) {
        console.log(item, "torusPalatinus")
        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          torus_palatinus: item.torus_palatinuses.map(torusPalatinuses => ({
            system: torusPalatinuses.system,
            code: torusPalatinuses.code,
            display: torusPalatinuses.display
          }))
        };


        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-torus-palatinus',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });

          // UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const PostDataToothTorusMandibularis = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothTorusMandibularis) {
        console.log(item, "torusMandibularis")
        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          torus_mandibularis: item.torus_mandibularises.map(torusMandibularises => ({
            system: torusMandibularises.system,
            code: torusMandibularises.code,
            display: torusMandibularises.display
          }))
        };


        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-torus-mandibularis',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });

          // UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const PostDataToothPalatum = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothPalatum) {
        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          palata: item.palata.map(palatum => ({
            system: palatum.system,
            code: palatum.code,
            display: palatum.display
          }))
        };


        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-palatum',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });

          // UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const PostDataToothDiastema = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothDiastema) {
        const firstDiastema = item.diastemas?.[0];

        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          diastema: item.diastemas.map(diastema => ({
            system: diastema.system,
            code: diastema.code,
            display: diastema.display,
            description: firstDiastema.description
          }))
        };

        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-diastema',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });

          // UpdateDataProcedureSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp);
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };


  const PostDataToothAnomali = async (patient_id, id) => {
    try {

      const responsePatient = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': responsePatient?.data?.entry[0].resource?.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      for (const item of dataToothAnomali) {
        const firstAnomali = item.anomalis?.[0];

        const payload = {
          patient_id: responsePatient?.data?.entry[0].resource?.id,
          encounter_id: responseEncounter?.data?.entry[0].resource?.id,
          created_at: `${getDataPhysicalCheck?.created_at.split(" ")[0]}T${getDataPhysicalCheck?.created_at.split(" ")[1]}+00:00`,
          anomali: item.anomalis.map(anomali => ({
            system: anomali.system,
            code: anomali.code,
            display: anomali.display,
            description: firstAnomali.description
          }))
        };

        const response = await axios.post(
          'https://api-ts.signatureanugerah.co.id/api/satu-sehat/tooth-anomali',
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          props.GetResponseData();
          swal({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            timer: 5000,
            buttons: false,
          });
        }
      }

      setLoading(false);
    } catch (error) {
      swal({
        title: 'Failed',
        text: error?.response?.data?.message || 'Unexpected error',
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const PostDataKeluhanUtama = async (patient_id, id) => {
    try {

      if (!getDataPhysicalCheckAppointment) {
        return;
      }


      const icd9Codes = dataMedicalRecord?.medical_treatment_invoices
        ?.map(invoice => {
          const treatmentData = invoice?.medical_record?.treatment_plan_detail;
          if (treatmentData && treatmentData.description) {
            return {
              anamnesa: treatmentData.description
            };
          }
          return null;
        })
        .filter(Boolean);


      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/chief-complaints',
        {
          "patient_id": patient_id,
          "anamnesa": getDataPhysicalCheckAppointment?.anamnesa,
          "complaint": getDataPhysicalCheckSoapPatient?.subjective,
          "code": icd9Codes,
          "encounter_id": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false,
        });

        UpdateDataConditionSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
        setLoading(false);
      }
    } catch (error) {
      if (error.response.data.issue[0].code !== "duplicate") {
        swal({
          title: 'Failed',
          // text: error?.response?.message,
          text: "heloo",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  };
  const PostDataGolonganDarah = async (patient_id, id) => {
    try {
      if (!getDataPhysicalCheckAppointment) {
        return;
      }

      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/blood-type',
        {
          "patient_id": patient_id,
          "encounter_id": id,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`,
          "blood_type": `${getDataPhysicalCheck?.blood_type}`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false,
        });

        UpdateDataConditionSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
        setLoading(false);
      }
    } catch (error) {
      if (error.response.data.issue[0].code !== "duplicate") {
        swal({
          title: 'Failed',
          text: error?.response?.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  };

  const PostDataRiwayatPenyakit = async (patient_id, id) => {
    try {
      // "med_allergy",
      // "med_consuming",
      const keysToExtract = [
        "surgery_history",
        "cardiac_disease",
        "hemophillia",
        "diabetes",
        "hepatitis",
        "gastritis",
        "special_condition"
      ];
      const historyOfIllness = keysToExtract
        .map(key => getDataPhysicalCheck[key])
        .filter(value => value !== null && value !== '')
        .map(display => {
          return {
            code: "472969004",
            display,
            system: "http://snomed.info/sct"
          }
        });


      if (historyOfIllness.length === 0) {
        swal({
          title: 'Failed',
          text: "Tidak ada data riwayat penyakit yang dikirim",
          icon: 'error',
          timer: 3000,
          buttons: false
        })
        return;
      }

      const response = await axios.post('https://api-ts.signatureanugerah.co.id/api/satu-sehat/history-of-illness',
        {
          "encounter_id": id,
          "patient_id": patient_id,
          "complaint": getDataPhysicalCheckSoapPatient?.subjective,
          // "code": historyOfIllness,
          "disease": historyOfIllness,
          "patient_firstname": `${getDataPatients?.first_name}`,
          "patient_lastname": `${getDataPatients?.last_name}`
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `${token}`
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        props.GetResponseData()
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false,
        });

        UpdateDataConditionSSPLocal(patient_id, getDataAppointmentSsp?.id_appointment_ssp)
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)
      if (error.response.data.issue[0].code !== "duplicate") {
        swal({
          title: 'Failed',
          text: error?.response?.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  };

  const PostDataPatient = async (patient_id) => {
    try {
      const token = localStorage.getItem('token');


      const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
        params: {
          'id_nik': `${getDataPatients?.nic_number}`
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });



      let patientId;
      if (!response?.data?.entry || response?.data?.entry.length === 0) {
        const newPatient = await axios.post(
          `https://api-ts.signatureanugerah.co.id/api/satu-sehat/patient`,
          {
            nic_number: getDataPatients?.nic_number,
            first_name: getDataPatients?.first_name,
            last_name: getDataPatients?.last_name,
            phone_number: getDataPatients?.phone_number,
            gender: getDataPatients?.gender,
            date_birth: getDataPatients?.date_birth,
            residence_address: getDataPatients?.residence_address,
            province: getDataPatients?.province,
            regency: getDataPatients?.regency,
            district: getDataPatients?.district,
            sub_district: getDataPatients?.sub_district,
            status: getDataPatients?.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`,
            }
          }
        );

        patientId = newPatient?.id;
      } else {
        patientId = response.data.entry[0].resource.id;
      }

      const responseEncounter = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
        params: {
          'id_patient': patientId
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${token}`,
        }
      });


      if (form?.appointment_ssp === "" && response?.data?.entry.length === 0) {
        const responseSSP = await API.post("/user-service/appointment-ssp/store", {
          id_appointment: form?.id_appointment,
          id_appointment_ssp: responseEncounter?.data?.entry[0].resource?.id,
          id_patient: form?.id_patient,
          id_patient_ssp: patient_id,
          status_sistole_ssp: 0,
          status_distole_ssp: 0,
          status_observation_ssp: 0,
          status_diagnosis_ssp: 0,
          status_procedure_ssp: 0,
          status_condition_ssp: 0,
          status_odontogram_ssp: 0
        }, fetchParams);

        if (responseSSP.status === 200) {

          swal({
            title: 'Success',
            text: 'Appointment berhasil disimpan!',
            icon: 'success',
            timer: 3000,
            buttons: false
          });
          // GetResponseDataToothCondition(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id);
          // PostDataToothOcclusion(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
          // PostDataToothTorusPalatinus(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
          // PostDataToothTorusMandibularis(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
          // PostDataToothPalatum(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
          // PostDataToothDiastema(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
          // PostDataToothAnomali(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id)
        }
      }

      PostDataPatientEcounter(response?.data?.entry[0].resource?.id, responseEncounter?.data?.entry[0].resource?.id);
      // Insert data for login process
      if (form?.appointment_ssp === "" && response?.data?.entry.length !== 0) {
        if (getDataAppointmentSsp.length === 0) {
          const responseSSP = await API.post("/user-service/appointment-ssp/store", {
            id_appointment: form?.id_appointment,
            id_appointment_ssp: responseEncounter?.data?.entry[0].resource?.id,
            id_patient: form?.id_patient,
            id_patient_ssp: response.data.entry[0].resource.id,
            status_sistole_ssp: 0,
            status_distole_ssp: 0,
            status_observation_ssp: 0,
            status_diagnosis_ssp: 0,
            status_procedure_ssp: 0,
            status_condition_ssp: 0,
            status_odontogram_ssp: 0,
          }, fetchParams);


          if (responseSSP.status === 200) {
            swal({
              title: 'Success',
              text: 'Appointment berhasil disimpan!',
              icon: 'success',
              timer: 3000,
              buttons: false
            });

            await PostDataGolonganDarah(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            // GetResponseDataToothCondition(patient_id, responseEncounter?.data?.entry[0].resource?.id);
            // PostDataToothOcclusion(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            // PostDataToothTorusPalatinus(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            // PostDataToothTorusMandibularis(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            // PostDataToothPalatum(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            // PostDataToothDiastema(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            // PostDataToothAnomali(patient_id, responseEncounter?.data?.entry[0].resource?.id)
            GetResponseDataAppointmentSSPByIdAppointment()
          }
        } else {
          if (buttonText === "Kirim Data Physical Check") {

            await PostDataPatientSistole(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            await PostDataPatientDistole(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            await PostDataPatientSuhu(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            await PostDataDiagnosis(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            await PostDataTindakan(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            // await PostDataKeluhanUtama(patientId, getDataAppointmentSsp?.id_appointment_ssp);
            // await PostDataRiwayatPenyakit(patientId, getDataAppointmentSsp?.id_appointment_ssp);
          }
          PostDataPatientEcounter(response.data.entry[0].resource.id, responseEncounter?.data?.entry[0].resource?.id);
        }
      }
    } catch (error) {
      if (error.response.data.issue[0].code !== "duplicate") {
        swal({
          title: 'Failed',
          text: error?.response?.message,
          icon: 'error',
          timer: 3000,
          buttons: false
        })
      }
    }
  }

  const handleSubmit = async () => {
    try {
      if (getDataPhysicalCheck.length === 0) {
        swal({
          title: 'Failed',
          text: `Pemeriksaan fisik pasien wajib diisi.`,
          icon: 'warning',
          timer: 3000,
          buttons: false
        });
        return;
      }

      if (
        getDataPatients?.province === null ||
        getDataPatients.province.trim() === "" ||
        getDataPatients?.regency === null ||
        getDataPatients.regency.trim() === "" ||
        getDataPatients?.district === null ||
        getDataPatients.district.trim() === "" ||
        getDataPatients?.sub_district === null ||
        getDataPatients.sub_district.trim() === ""
      ) {
        swal({
          title: 'Failed',
          text: `Data domisili pasien diperlukan untuk melanjutkan proses ini.`,
          icon: 'warning',
          timer: 3000,
          buttons: false,
        });
        return;
      }

      if (
        getDataPatients?.nic_number === null ||
        getDataPatients?.nic_number === "null" ||
        getDataPatients.nic_number.trim() === ""
      ) {
        swal({
          title: 'Failed',
          text: `Harap isi NIK pasien!`,
          icon: 'warning',
          timer: 3000,
          buttons: false,
        });
        return;
      }
      await PostDataPatient();
    } catch (error) {
      swal({
        title: 'Success',
        text: 'Data berhasil dikirim ke Satu Sehat.',
        icon: 'success',
        timer: 3000,
        buttons: false
      });
    }
  };

  useEffect(() => {
    if (getDataAppointmentSsp) {
      const appointmentExists = !!getDataAppointmentSsp.id_appointment_ssp;
      const hasAnyStatusZero =
        getDataAppointmentSsp.status_sistole_ssp === 0 ||
        getDataAppointmentSsp.status_distole_ssp === 0 ||
        getDataAppointmentSsp.status_diagnosis_ssp === 0 ||
        getDataAppointmentSsp.status_procedure_ssp === 0 ||
        getDataAppointmentSsp.status_observation_ssp === 0 ||
        getDataAppointmentSsp.status_odontogram_ssp === 0 ||
        getDataAppointmentSsp.status_condition_ssp === 0;


      setIsAppointmentExists(appointmentExists);
      if (!getDataAppointmentSsp) {
        if (!dataMedicalRecord) {
          setButtonText("Loading");
        } else {
          setButtonText("Kirim Encounter");
        }
      } else if (appointmentExists && hasAnyStatusZero) {
        setButtonText("Kirim Data Physical Check");
      } else {

        const fetchPatientData = async () => {
          setLoading(true)
          try {
            const responsePasienLocal = await API.get(
              `/transaction-service/patients/${form?.id_patient}`,
              fetchParams
            );
            const responsePasien = await axios.get(
              `https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`,
              {
                params: {
                  'id_nik': responsePasienLocal.data.data.nic_number
                },
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `${token}`,
                }
              }
            );

            if (responsePasien.data.entry.length > 0) {
              setButtonText("Terkirim")
              setButtonColor("success")
              setButtonDisable("disabled")

            }
          } catch (error) {

          }
        };


        fetchPatientData();
      }
    }
  }, [getDataAppointmentSsp]);


  return (
    <Modal {...props} aria-labelledby="contained-modal-title-center" centered style={{ fontFamily: "sans-serif", border: "none" }}>
      {loading && <LoaderHome />}
      <div style={{ width: "100%", display: "flex", padding: "10px 0px", backgroundColor: "#29B8FF" }}>

        <div style={{ flex: "92%", fontSize: "20px", display: "flex", alignItems: "center", paddingLeft: "10px", color: "white", fontWeight: "600" }}>
          Satu Sehat || {form?.patient_name}
        </div>

        <div style={{ flex: "8%", fontSize: "30px", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
          <FaTimes onClick={props.onHide} style={{ cursor: "pointer" }} />
        </div>
      </div>
      <Modal.Body style={{ backgroundColor: "", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", border: "none" }}>
        <Form className="mt-" >
          <Col xl='12' sm='12'>

            <div style={{ display: "flex", justifyContent: "center", padding: "0px 0px" }}>
              <img
                src={logo_kemenkes}
                style={{ minWidth: "320px", maxWidth: "320px", minHeight: "250px", maxHeight: "250px" }}
              />
            </div>

            <div className="" style={{ display: "flex", justifyContent: "center" }}>
              {/* <div>
                {
                  getDataAppointmentSsp?.id_appointment_ssp !== null &&
                    (
                      getDataAppointmentSsp?.status_sistole_ssp === 0 ||
                      getDataAppointmentSsp?.status_distole_ssp === 0 ||
                      getDataAppointmentSsp?.status_diagnosis_ssp === 0 ||
                      getDataAppointmentSsp?.status_procedure_ssp === 0 ||
                      getDataAppointmentSsp?.status_distole_ssp === 0 ||
                      getDataAppointmentSsp?.status_observation_ssp === 0
                    ) ?
                    <>
                      <Button className="mt-2" onClick={handleSubmit} color='primary' block style={{ padding: "8px 15px", fontSize: "12px", borderRadius: "5px" }}>
                        <FaTelegramPlane /> Kirim Data Physical Check
                      </Button>
                    </>
                    :
                    <>
                      <Button className="mt-2" color='primary' block style={{ padding: "8px 15px", fontSize: "12px", borderRadius: "5px" }}>
                        <FaTelegramPlane /> Loading
                      </Button>
                    </>
                }

                {
                  getDataAppointmentSsp?.id_appointment_ssp === null &&
                    getDataAppointmentSsp?.status_sistole_ssp === 0 &&
                    getDataAppointmentSsp?.status_distole_ssp === 0 &&
                    getDataAppointmentSsp?.status_diagnosis_ssp === 0 &&
                    getDataAppointmentSsp?.status_procedure_ssp === 0 &&
                    getDataAppointmentSsp?.status_observation_ssp === 0 ?
                    <>
                      <Button className="mt-2" onClick={handleSubmit} color='primary' block style={{ padding: "8px 15px", fontSize: "12px", borderRadius: "5px" }}>
                        <FaTelegramPlane /> Kirim Encounter
                      </Button>
                    </>
                    :
                    <>
                      <Button className="mt-2" onClick={handleSubmit} color='primary' block style={{ padding: "8px 15px", fontSize: "12px", borderRadius: "5px" }}>
                        <FaTelegramPlane /> Loading
                      </Button>
                    </>
                }
              </div> */}
              <Button
                className="mt-2"
                onClick={handleSubmit}
                color={buttonColor}
                block
                {...buttonDisable}
                style={{ padding: "8px 15px", fontSize: "12px", borderRadius: "5px" }}
              >
                <FaTelegramPlane /> {buttonText}
              </Button>
            </div>
          </Col>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
